import KycPageSignals from "@/features_signal/kyc/kycPageSignals"

export default function StepKycTakeIdSelfieResult() {
    return (
        <div>
            <h2>自拍照片結果</h2>
            <div>
                <img
                    src={KycPageSignals.sourceData.value.kyc?.attachments_faceTmpUrl}
                    alt="自拍照片"
                />
            </div>
            <div>
                <button>重新拍攝</button>
                <button>確認並繼續</button>
            </div>
        </div>
    )
}
